









































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import PhoneInput from "@/views/components/FormInputs/PhoneInput.vue";
import Dialog from "@/views/Dialog/Dialog.vue";
import ResendVerification from "@/views/Dialog/views/ResendVerification.vue";
import CheckBox from '../../FormInputs/CheckBox.vue';

import {IRegister} from "@/models/loginModels";
import {errorHandler} from "@/services/services";
import {IApiErrors} from "@/models/ApiModels";
import {OTHER_ROUTES} from "@/constants/routes";
import {
  isRegisterPhoneAndCodeUrl,
  isRegisterEmailAndCodeUrl,
  isLoginRegisterResetOrValidationUrl,
  isRegisterEmailAndPhoneCodeUrl,
} from '@/services/routeHelper';
import {path} from "ramda";
import {AxiosError} from "axios";
import {ANALYTIC_CLICKS} from "@/services/Analytics";
import {isErrorType} from '@/services/errorHandling';
import {DroppoErrors} from "@/constants/errors";
import {Languages} from "@/constants/locale";
import {stripHtmlTags} from "@/helpers/stringHelpers";

const userDataModule = namespace("userData");

@Component({
  name: 'RegisterForm',
  components: {
    PhoneInput,
    Dialog,
    ResendVerification,
    CheckBox,
  },
})
export default class RegisterForm extends Vue {
  @userDataModule.Action('registerUser')
  private registerUser !: (userData: IRegister) => Promise<any>;

  @userDataModule.Action('registerUserWithVCode')
  private registerUserWithVCode !: (userData: IRegister) => Promise<any>;

  @userDataModule.Action('registerUserPhoneAndCode')
  private registerUserPhoneAndCode !: (userData: IRegister) => Promise<any>;

  @userDataModule.Getter("getLanguage")
  private getLanguage!: Languages;

  @Prop({default: true})
  private emitNextAtLogin !: boolean;

  private firstName: string = "";
  private lastName: string = "";
  private email: string = "";
  private internationalPhoneNumber: string = ""; // in here we have the phone with the code
  private password: string = "";
  private repeatPassword: string = "";
  private tosChecked: boolean = false;

  private loading: boolean = false;
  private showResendVerification: boolean = false;
  private errors: IApiErrors = {};

  private verificationCode: string = '';

  private get isRegisterPhoneAndCode(): boolean {
    return isRegisterPhoneAndCodeUrl(this.$route);
  }

  private get isRegisterEmailAndPhoneCode(): boolean {
    return isRegisterEmailAndPhoneCodeUrl(this.$route);
  }

  private get isRegisterEmailAndCode(): boolean {
    return isRegisterEmailAndCodeUrl(this.$route);
  }

  private get isRegisterByCode(): boolean {
    return this.isRegisterEmailAndCode || this.isRegisterEmailAndPhoneCode || this.isRegisterPhoneAndCode;
  }

  private get activeButton() {
    return this.firstName !== ""
        && this.lastName !== ""
        && this.email !== ""
        && this.internationalPhoneNumber !== ""
        && this.password !== ""
        && this.repeatPassword !== "";
  }

  @Watch("$route")
  private updateIfPhoneRegister() {
    if (this.isRegisterByCode) {
      this.routeParamsOperation();
    }
  }

  @Watch("errors")
  private errorWatcher() {
    if (this.errors.verification_code) {
      this.$uiBus.emit('genericError:show', this.$t('errors.verification_code'));
    }
  }

  private created() {
    this.updateIfPhoneRegister();
  }

  private sanitizeInputs() {
    this.firstName = stripHtmlTags(this.firstName);
    this.lastName = stripHtmlTags(this.lastName);
    this.internationalPhoneNumber = stripHtmlTags(this.internationalPhoneNumber);
    this.email = stripHtmlTags(this.email);
  }

  private routeParamsOperation() {
    const phonePath = ['params', 'phone'];
    const emailPath = ['params', 'email'];
    const codePath = ['params', 'vCode'];

    const email: string|undefined = path(emailPath, this.$route);
    const phone: string|undefined = path(phonePath, this.$route);
    const code: string|undefined = path(codePath, this.$route);

    this.email = email ? email : "";
    this.internationalPhoneNumber = phone ? phone : "";
    this.verificationCode = code ? code : "";
  }

  private returnToHomeUrlIfNecessary() {
    // we need those urls to clean because if the user saves them, they will always reset their credentials
    if (isLoginRegisterResetOrValidationUrl(this.$route)) {
      this.$router.push({name: OTHER_ROUTES.HOME});
    }
  }

  private showTos() {
    this.$uiBus.emit("dialog:tosText:show");
  }

  private sendRegisterForm() {
    // here we start the login
    if (this.activeButton) {
      this.sanitizeInputs();
      ANALYTIC_CLICKS.registerButton(this.$gtag);
      this.clearErrors();
      this.loading = true;

      const registerBody: IRegister = {
        first_name: this.firstName,
        last_name: this.lastName,
        phone: this.internationalPhoneNumber,
        email: this.email,
        password: this.password,
        password_confirmation: this.repeatPassword,
        verification_code: this.verificationCode, // we will ignore this field in normal register
        language: this.getLanguage,
        tos: this.tosChecked,
      };

      const myPromise: Promise<any> = this.isRegisterByCode ? this.registerUserWithVCode(registerBody)
                                                            : this.registerUser(registerBody);

      myPromise
          .then(() => this.returnToHomeUrlIfNecessary())
          .then(() => this.$uiBus.emit("how-it-works:show"))
          .catch(this.showErrors)
          .finally(() => this.loading = false);
    }
  }

  private showErrors(err: AxiosError) {
    if (isErrorType(DroppoErrors.USER_CREATED_BY_PHONE_ERROR, err)) {
      this.showResendVerification = true;
    } else {
      const errors = errorHandler.handleErrorsResponse(err, 'registerForm.errors');
      Vue.set(this, 'errors', errors);
    }
  }

  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private removeError(e: any) {
    Vue.set(this.errors, e, '');
  }

}
